import { ErrorLevel } from '@griply/utils';
import { getErrorReporter } from 'shared/services/error-tracking';

import { AppDomainVerdict, getAppDomainCheck } from './get-app-domain-check';

const MAX_REPORTED_HOST_LENGTH = 100;

let hasRun = false;

// Runs before render, but not before the loaders: createBrowserRouter navigates at module scope.
export const enforceAppDomain = () => {
  if (hasRun) {
    return;
  }
  hasRun = true;

  const { hostname, pathname, search } = window.location;
  const environment = import.meta.env.VITE_ENVIRONMENT;

  const check = getAppDomainCheck({
    hostname,
    pathname,
    search,
    environment,
    allowLocalhost: import.meta.env.VITE_ALLOW_LOCALHOST === 'true',
  });

  if (check.verdict === AppDomainVerdict.Ok) {
    return;
  }

  if (check.verdict === AppDomainVerdict.Unconfigured) {
    getErrorReporter().captureMessage(
      'domain guard disabled: unknown VITE_ENVIRONMENT',
      ErrorLevel.Error,
      {
        tags: { source: 'domain-guard' },
        extra: { environment },
        fingerprint: ['domain-guard-unconfigured'],
      },
    );
    return;
  }

  getErrorReporter().captureMessage(
    'app served from unexpected host',
    ErrorLevel.Error,
    {
      tags: { source: 'domain-guard', environment },
      extra: {
        actualHost: hostname.slice(0, MAX_REPORTED_HOST_LENGTH),
        pathname: check.pathname,
        searchParamKeys: check.searchParamKeys,
      },
      // Constant: the hostname is attacker-chosen, and wildcard DNS would mint one issue per request.
      fingerprint: ['domain-guard'],
    },
  );

  window.location.replace(check.redirectUrl);
};

export const __resetAppDomainGuardForTests = () => {
  hasRun = false;
};
